<efx-modal
  [(show)]="showModal"
  [showFooter]="false"
  [title]="flowTableModal?.concat(' ', itemMenuSelected?.subDomain | titlecase )"
  [showCancel]="false"
  [preventDefaultClose]="true"
  [size]="modalSize"
  (onHide)="closetModal()"
  (onSubmit)="onSubmit()"
  >
  @if (showModal) {
    <section
      class="d-flex flex-column overflow-auto"
      [ngClass]="flowTableModal == OptionsFlowTable.VistaPrevia ? 'gap-5': 'gap-3'"
      >
      <app-tabla-dinamica-buscador
        [inFlowTable]="flowTableModal"
        [inStructField]="inStructModal"
        [inDataValues]="inData">
      </app-tabla-dinamica-buscador>
      @if (flowTableModal !== OptionsFlowTable.VistaPrevia) {
        <section class="buttonsSave">
          <button class="efx-button-secondary" (click)="closetModal()">Cancelar</button>
          <button class="efx-button-primary" (click)="onSubmit()">
            <span class="material-symbols-outlined"> save </span>
            Guardar
          </button>
        </section>
      } @else {
        <section class="d-flex justify-content-center">
          <button class="efx-button-primary" (click)="closetModal()">
            <span class="material-symbols-outlined"> close </span>
            Cerrar
          </button>
        </section>
      }
    </section>
  }

</efx-modal>
